import type { RouteRecordRaw } from "vue-router";

import MixingRoutes from "../enums/routes/MixingRoutes";
//import BetaMixingLayout from "../layout/app/beta/MixingLayout.vue";
import MixingLayout from "../layout/app/production/MixingLayout.vue";

export function mixingRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/mixing",
            component: MixingLayout,
            children: [
                {
                    path: "/mixing",
                    name: MixingRoutes.MIXING,
                    component: () => import("../views/apps/mixing/MixingSignInView.vue"),
                },
                {
                    path: "/mixing/user",
                    name: MixingRoutes.USER,
                    component: () => import("../views/apps/mixing/MixingUserView.vue"),
                },
                {
                    path: "/mixing/settings",
                    name: MixingRoutes.SETTINGS,
                    component: () => import("../views/apps/mixing/MixingUserSettingsView.vue"),
                },
                {
                    path: "/mixing/settings/tablet-id",
                    name: MixingRoutes.TABLETID,
                    component: () => import("../views/apps/mixing/MixingUserSettingsTabletIdView.vue"),
                },
                {
                    path: "/mixing/batch",
                    name: MixingRoutes.BATCH,
                    component: () => import("../views/apps/mixing/MixingBatchView.vue"),
                },
            ],
        },
    ];
}
